<template>
  <div>
    <div class="chart-box-top">
      <span class="chart-title">国际运输航空致命事故数（月度）</span>
    </div>
    <div ref="chart" class="chart-main">
    </div>
    <el-dialog title="明细列表" :visible.sync="detailVisible" width="95%">
      <AccidentDetail ref="detail" :year="barYear" :month="barMonth"></AccidentDetail>
    </el-dialog>
  </div>
</template>

<script>
import {getRequest} from "../../../utils/request";
import AccidentDetail from "./AccidentDetail";

export default {
  props: {
    year: Number,
    reload: Boolean,
  },
  data() {
    return {
      xAxisData: [],
      accidentNum: [],
      deathToll: [],
      //是否显示明细列表
      detailVisible: false,
      //用户点击的年份
      barYear: null,
      //用户点击的月份
      barMonth: null,
      chart: null,
    }
  },
  mounted() {
    this.buildAccidentMonth();
    window.addEventListener('resize', () => {
      this.chart && this.chart.resize()
    })
  },
  watch: {
    year() {
      this.buildAccidentMonth();
    },
    reload() {
      this.buildAccidentMonth();
    },
  },
  methods: {
    /**
     * 国际运输航空致命事故数（月度）
     */
    buildAccidentMonth() {
      getRequest("/result/accident/chart/monthly", {
        endYear: this.year
      }, this.$refs.chart).then(res => {
        this.xAxisData = [];
        this.accidentNum = [];
        this.deathToll = [];

        res.data.forEach(item => {
          this.xAxisData.push(item.year + "/" + item.prettifyMonth);
          this.accidentNum.push({value: item.fatalAccidentCount, full: item});
          this.deathToll.push({value: item.deathToll, full: item});
        })

        this.chart = this.$echarts.init(this.$refs.chart);
        this.chart.setOption(this.accidentMonthOption());

        this.chart.on("click", "series.bar", params => {
          this.barYear = params.data.full.year;
          this.barMonth = params.data.full.month;
          this.detailVisible = true;
          this.$refs.detail && this.$refs.detail.initPage();
        })

        this.$util.adjustYaxis(this.chart, this.$util.getMax(this.deathToll));
      })
    },
    accidentMonthOption() {
      return {
        xAxis: {
          data: this.xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
          axisLabel: {
            color: "#bebebe",
            fontSize: 12,
            interval: 0,
            rotate: -90
          },
        },
        grid: {
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          padding: [5, 10],
          confine: true
        },
        yAxis: [
          {
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLabel: {
              color: "#bebebe",
              fontSize: 12,
            },
            name: "起",
            nameTextStyle: {
              color: "#bebebe",
              fontSize: 11,
              //"起"字与左y轴对齐
              align: "right",
              padding: [0, 5, 0, 0]
            },
          },
          {
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLabel: {
              color: "#bebebe",
              fontSize: 12,
            },
            name: "人",
            nameTextStyle: {
              color: "#bebebe",
              fontSize: 12,
              //"人"字与右Y轴对齐
              align: "left",
              padding: [0, 0, 0, 15]
            },
          },
        ],
        legend: {
          itemWidth: 12,
          itemHeight: 12,
        },
        series: [
          {
            name: "致命事故数",
            type: "bar",
            symbol: "none",
            itemStyle: {
              normal: {
                color: "#198AFF",
              },
            },
            barWidth: 10,
            data: this.accidentNum,
            animationDuration: 1000,
            animationEasing: "quadraticOut",
          },
          {
            name: "事故死亡人数",
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "#F7B400",
                lineStyle: {
                  color: "#F7B400",
                  width: 2,
                },
              },
            },
            type: "line",
            symbol: "circle",
            symbolSize: "5",
            data: this.deathToll,
            animationDuration: 1000,
            animationEasing: "quadraticOut",
          }
        ],
      };
    },
  },
  components: {
    AccidentDetail
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/achievement/result/AccidentMonth.vue